module.exports = __webpack_public_path__ + "static/media/Samy_Cherfaoui.eb019c5c.png";